import React from "react";

const ServiceCard = ({ para, heading, pending }) => {
  return (
    <div className="bg-white rounded-sm shadow-sm pl-4 mt-lg-0 mt-5 py-4 ">
      <div className="d-flex">
        <div className="bg d-flex justify-content-center align-items-center">
          <img src="/assets/images/Vector.svg" alt="" />
        </div>
        <div className=" ml-3">
          <p className="total m-0 pb-2">{para}</p>
          {/* <h1 className='fifty_two m-0 p-0'>{heading}</h1> */}
          {pending ? (
            <div className="w-100 d-flex align-items-center justify-content-between mb-2">
              <div class="spinner-border fifty_two mx-auto" role="status"></div>
            </div>
          ) : (
            <h1 className="fifty_two m-0 p-0">{heading}</h1>
          )}
        </div>
      </div>
      <div className="pr-5">
        <hr className="" />
        <p className="color1">pervious week</p>
      </div>
    </div>
  );
};

export default ServiceCard;
